import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import SweetAlert from "sweetalert2"
import { Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import formatDate from '../../../../Functions/Traitement/fomatDate' //'../../../function/FormDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate'
import DataPeriod1 from "../../../../Functions/Traitement/DataPeriodAuto"
import Data from '../../../../Data/Data.json'
import Table, { ColumnsType } from 'antd/es/table';
import Tab3 from './Tabhisto';
import { Spin } from 'antd';
import { Crypter } from '../../../../Functions/Security/Crypter';
import Utilisateur from '../../../../Models/Utilisateur';
 

// DECLARATION DES COLONNES DU TABLEAU
const columns: ColumnsType<DataPeriod1> = [
    {
        title: 'N° CREDIT',
        dataIndex: 'NUMCRD',

    },
    {
        title: 'ID CLIENT',
        dataIndex: 'NUMCLI',
    },
    {
        title: 'NOM CLIENT',
        dataIndex: 'NOMCLI',
    },
    {
        title: 'NOM SERVICE',
        dataIndex: 'SERVGE',
    },
    {
        title: 'Nat CREDIT',
        dataIndex: 'NATCRD',
    },
    {
        title: 'MONTANT',
        dataIndex: 'MNTAUT',
    },
    {
        title: 'DATE EFFET',
        dataIndex: 'DATEFF',
    },
    {
        title: 'DATE LIMITE',
        dataIndex: 'DATEFIN',
    }
];


const HistoAutorisation = () => {

    // USER SESSION
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))


    //  declaration des usestates

    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(true)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [supActive, setSupActive] = useState(true)
    const [impActive, setImpActive] = useState(true)
    const [actuActive, setActActive] = useState(true)
    const [annulActive, setAnnulActive] = useState(true)
    const [consult, setConsult] = useState(false)
    const [donnees, setData] = useState<DataPeriod1[]>([]);
    const [FormAct, setFormactve] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false)

    useEffect(() => {
        forceUpdate({});
    }, []);

    //  declaration des Handles
    const setajout = () => {
        setEnregActve(true)
        setAjoutActif(true)
        setAnnulActive(false)
        setSearchGlobal(true)
        setModifActve(false)
        setSupActive(false)
    }
    const SetStart = () => {
        setAjoutActif(true)
        setEnregActve(false)
        setAnnulActive(false)
        setModifActve(true)
        setSupActive(true)
        setSearchGlobal(true)
        form.resetFields()
        setActActive(false)
    }
    const SetEndStart = () => {
        SetStartForm(true);
        setSearchGlobal(false)
        setModifActve(false)

    }
    const setajoutt = () => {
        setEnregActve(true)
        setAjoutActif(true)
        setAnnulActive(false)
        setSearchGlobal(true)
        setModifActve(false)
        setSupActive(false)
        setConsult(true)
    }
    function handlenreg() {
        setSearchGlobal(false)
        setConsult(false)
        setAjoutActif(false)
        setAnnulActive(true)
        setModifActve(true)
        setSupActive(true)
        setActActive(true)
    }
    function handleAnulle() {
        setAjoutActif(false)
        setAnnulActive(true)
        setSearchGlobal(false)
        setModifActve(true)
        setSupActive(true)
        form.resetFields()
        setActActive(true)
        setConsult(false)
    }

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '3',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    HISTORIQUE AUTO
                </span>
            ),
            children: <Tab3 form={form} /*form={form}*/ />, //form={form}
        },
    ]

    // pour la selection des element dans le tableau

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed: ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
    };


    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    // function consult du tab

    function Consultab() {
        
        //etat de recharge
        localStorage.setItem(Data.LocalVariable.reset, "1");

        if ((form.getFieldValue("DATEFF") === null) || (form.getFieldValue("DATEFIN") === null)) {

            let date1 = Crypter.encrypt(JSON.stringify(formatDate(('1900-01-01'))));
            let date2 = Crypter.encrypt(JSON.stringify(formatDate(('2099-01-01'))));
            let choix = Crypter.encrypt((JSON.stringify('0')))
            let agence = Crypter.encrypt('0')
            let natcrd = Crypter.encrypt('201')

            if (date1.length != 0 && date2.length != 0) {
                // initialiazeButton()
                setLoading(true)

                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.HistoriqueAutori,
                    headers: {
                        'CyphereAgence': agence,
                        'CyphereNatcrd': natcrd,
                        'CyphereDateff': date1,
                        'CyphereDatelimit':date2,
                        'CyphereChoix': choix,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        
                        if (response.data) {
                            alert('one 1++') 
                            let datas = response.data.Result;
                            datas.map((val: any, key: any) => {
                                dat.push({
                                    key: key,
                                    NUMCRD: val.NUMCRD,
                                    NUMCLI: val.NUMCLI,
                                    NOMCLI: val.NOMCLI,
                                    SERVGE: val.SERVGE,
                                    NATCRD: val.NATCRD,
                                    MNTAUT: val.MNTAUT,
                                    DATEFF: val.DATEFF,
                                    DATEFIN: val.DATELIMIT,
                                    CPTAUT :val.CPTAUT,
                                    CDETAT:val.CDETAT
                                }
                                )
                            })

                            localStorage.clear()
                            localStorage.setItem(Data.LocalVariable.FirstValueAuto, Crypter.encrypt(JSON.stringify(dat)))
                            setData(dat);
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        } else {
            
            let date1 = Crypter.encrypt(JSON.stringify(formatDate(('1900-01-01'))));
            let date2 = Crypter.encrypt(JSON.stringify(formatDate(('2099-01-01'))));
            let choix = Crypter.encrypt(JSON.stringify("0"))
            let agence = Crypter.encrypt(JSON.stringify("0"))
            let natcrd = Crypter.encrypt(JSON.stringify("0"))

            if (date1.length != 0 && date2.length != 0) {
                // initialiazeButton()
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.HistoriqueAutori,
                    headers: {
                        'Cyphereagence': agence,
                        'Cypherenatcrd': natcrd,
                        'Cypheredateff': date1,
                        'Cypheredatelimit':date2,
                        'Cypherechoix': choix,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {

                            let datas = response.data.Result;

                            datas.map((val: any, key: any) => {

                                dat.push({
                                    key: key,
                                    NUMCRD: val.NUMCRD,
                                    NUMCLI: val.NUMCLI,
                                    NOMCLI: val.NOMCLI,
                                    SERVGE: val.SERVGE,
                                    NATCRD: val.NATCRD,
                                    MNTAUT: val.MNTAUT,
                                    DATEFF: val.DATEFF,
                                    DATEFIN: val.DATELIMIT,
                                    CPTAUT :val.CPTAUT,
                                    CDETAT:val.CDETAT
                                }
                                )
                            })

                            localStorage.clear()

                            localStorage.setItem(Data.LocalVariable.FirstValueAuto, Crypter.encrypt(JSON.stringify(dat)))
                            setData(dat);
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }

        }
    }

    // function Onfinish

    const onFinish = (values: any) => {

    };

    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    // return (
    //     <div className='tab'>
    //         <Typography align='center' className='formTitle'> <b>GESTION DE DemandAutoS </b> </Typography>
    //         <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
    //             <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={Consultab} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
    //                 <div className='bG'>
    //                     <legend><Typography color={"#116599"}>Actions</Typography></legend>
    //                     <Form.Item shouldUpdate className='bouttong'>
    //                         <Space direction="vertical" style={{ width: '100%' }}>
    //                             <Button size='large' className='bt_add' disabled={false} onClick={() => {  }} type="ghost" htmlType="button" block  >
    //                                 Afficher
    //                             </Button>
    //                             <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
    //                                 Imprimer
    //                             </Button>
    //                             <Button size='large' className='bt_add' disabled={actuActive} onClick={() => { form.resetFields();  }} type="ghost" htmlType="button" block  >
    //                                 Actualiser
    //                             </Button>
    //                         </Space>
    //                     </Form.Item>
    //                 </div>
    //                 <div className='clientP'>
    //                     <div >
    //                         <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
    //                     </div>
    //                     <div>
    //                         <Box style={{ display: 'flex', marginTop: 75 }} display={"flex"} fontStyle="inherit" >
    //                             <Spin spinning={loading}>
    //                                 <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio" }} style={{ width: '85%' }} columns={columns} scroll={{ y: 850, x: 20 }} pagination={false} />
    //                             </Spin>
    //                         </Box>
    //                     </div>
    //                 </div>
    //             </Form>
    //         </Spin>
    //     </div>
    // );

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> HISTORISATION AUTORISATION : {window.location.pathname.toUpperCase()}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>

                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultab() }} type="ghost" htmlType="button" block  >
                                    Afficher
                                </Button>
                                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                                    Imprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={actuActive} onClick={() => { form.resetFields(); }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                        </div>
                        <div>

                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );

}

export default HistoAutorisation;